<template>
  <div class="index">
    <!-- <img src="../assets/img/login-bg.png" alt="" class="head loginBox"> -->
    <div class="login">
      <div class="left">
        <div class="title">
          <img src="../assets/img/title.png" alt="医诺云检Saas报告单查询">
        </div>
        <div class="peoImg">
          <img src="../assets/img/people.png" alt="图标">
        </div>
      </div>
      <div class="right">
        <div class="light">
          <img src="../assets/img/light.png" cls alt="图标">
        </div>
        <div>
          <p>欢迎登录</p>
          <p><span>请输入准确的用户名和密码</span></p>
        </div>
        <Form ref="formInline" :model="formInline" :rules="ruleInline">
          <FormItem prop="user">
            <Input type="text" v-model="formInline.user" placeholder="用户名"/>
              <Icon type="ios-person-outline" slot="prepend"></Icon>
          </FormItem>
          <FormItem prop="password">
            <Input type="password" v-model="formInline.password" placeholder="密码"/>
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
          </FormItem>
          <FormItem>
            <Button type="primary" long @click="handleSubmit('formInline')">登录</Button>
          </FormItem>
          <p class="copy">版权所有&copy;医诺云检</p>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { tips } from "./../tools";
import { login } from "./../api/login";
import {isLogin} from './../api/common';
export default {
  data() {
    return {
      formInline: {
        user: "",
        password: ""
      },
      ruleInline: {
        user: [
          { required: true, message: "用户名不允许为空", trigger: "blur" },
          {
            type: "string",
            max: 11,
            message: "请填写正确格式手机号",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "密码不允许为空", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码长度不允许低于6位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created(){
    console.log(1111)
    let lett = this;
    document.onkeyup = function(e) {
    let key = window.event.keyCode;
    // console.log(key);
    if (key == 13) {
      lett.handleSubmit('formInline');
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        console.log(valid);
        if (valid) {
          // this.$Message.success('Success!');
          const data = {
            appType: 1,
            mobile: this.formInline.user, // 13867493176,
            password: this.formInline.password,
            userType: 3
          };
          login(data).then(res => {
            localStorage.setItem("his_token", res.token);
            this.isLogin();
          });
        } else {
          // this.$Message.error('Fail!');
          tips(this, "登录失败", "error");
        }
      });
    },
    isLogin(){
      isLogin().then(res=>{
        tips(this, "登录成功", "success");
        console.log(res);
        localStorage.setItem("his_pId", res.partnerId);
        let userObj = {
          hospitalName:res.hospitalName,
          userName:res.userName
        };
        this.$store.commit("setUserName", userObj);
          const menu = [
            // {
            //   icon: " iconfont icon-yuyueguahao2",
            //   name: "预约挂号",
            //   id: 1,
            //   url: "/appointment"
            // },
            // {
            //   icon: " iconfont icon-menzhen",
            //   name: "智能开单",
            //   id: 2,
            //   url: "/cliniclist"
            // },
            // {
            //   icon: " iconfont icon-jiaofei",
            //   name: "门诊收费",
            //   id: 3,
            //   url: "/waitcharge"
            // },
            // {
            //   icon: " iconfont icon-caiyang",
            //   name: "样本采集",
            //   id: 4,
            //   url: "/nosamp"
            // },
            // {
            //   icon: " iconfont icon-xiangmujiesuan",
            //   id: 5,
            //   name: "检测结算",
            //   url: "/noPay"
            // },
            {
              icon: " iconfont icon-baogaoguanli",
              name: "报告查询",
              id: 6,
              url: "/report"
            },
            {
              icon: " iconfont icon-huanzheguanli",
              name: "员工健康",
              id: 7,
              url: "/patient"
            },
            {
              icon: " iconfont icon-yuyueguahao2",
              name: "预约管理",
              id: 8,
              url: "/appointments"
            },
            // {
            //   icon: " iconfont icon-huanzheguanli",
            //   name: "患者管理",
            //   id: 7,
            //   url: "/patientmanager"
            // },
            // {
            //   icon: " iconfont icon-buchongbanli",
            //   name: "病历管理",
            //   id: 8,
            //   url: "/casemanage"
            // },
            // {
            //   icon: " iconfont icon-Settings-Help",
            //   name: "系统设置",
            //   id: 9,
            //   url: "/peoplemmanager"
            // },
            
            // {
            //   icon: " iconfont icon-yaofang",
            //   name: "药房",
            //   id: 7,
            //   url: "/pharmacy"
            // },
            // {
            //   icon: " iconfont icon-shujutongji",
            //   name: "数据统计",
            //   id: 7,
            //   url: "/statistics"
            // },
            // {
            //   icon: " iconfont icon-jiancexiangmukuguanli-",
            //   name: "检测项目",
            //   id: 7,
            //   url: "/inspectitem"
            // },
          ];
          this.$store.commit("setMenu", menu);
          this.$router.push(menu[0].url);
          
      });
    }
  }
};
</script>
<style lang="less" scoped>
  @media screen and (max-width:1280px){
    .index{
      display:table-cell;
      vertical-align: middle;
      position: relative;
      padding: 7.81%;
      background: -webkit-linear-gradient(#4aacf5, #208ddf); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(#4aacf5, #208ddf); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(#4aacf5, #208ddf); /* Firefox 3.6 - 15 */
      background: linear-gradient(#4aacf5, #208ddf); /* 标准的语法 */
      // background:red;
      width: 1280px;
      // min-height: 600px;
      height: 100%;
      // line-height: 936px;
      overflow: auto;
      .login{
        width: 1080px;
        height: 447px;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        border-radius: 13px;
        .left{
          width: 53%;
          padding: 66px 18px 18px;
          background-color: #F0FBFF;
          border-radius: 13px 0 0 13px;
          .title{
            height: 60px;
            line-height: 60px;
            text-align: center;
            img{
              width: 385px;
            }
          }
          .peoImg{
            text-align: center;
            img{
              width: 304px;
            }
          }
        }
        .right{
          position: relative;
          width: 47%;
          padding: 91px 73px 57px ;
          p{
            font-size: 24px;
            font-weight: 500;
            color: #3985BE;
            span{
              font-size: 14px;
              color: #97A5B8;
              font-weight: normal;
            }
          }
          p:last-child{
            line-height: 24px;
            span{
              display: inline-block;
              height: 24px;
              line-height: 24px;
            }
          }
          .ivu-form{
            // margin-top:32px;
            .ivu-form-item{
              margin-top: 20px;
            }
            .ivu-form-item:last-child{
              margin-top: 10px;
            }
            /deep/ .ivu-form-item-content {
              position: relative;
              line-height: 26px;
              font-size: 14px;
            }
            /deep/ .ivu-input{
              height: 42px;
              line-height: 42px;;
              font-size: 15px;
              padding-left: 18px;
            }
            /deep/ .ivu-btn{
              height: 42px;
              border-radius: 24px;
              margin-top: 35px;
              font-size: 15px;
            }
            p.copy{
              font-size: 14px;
              text-align: center;
              color:#babdc2;
            }
          }
          .light{
            position: absolute;
            top: 0;
            right: 48px;
            img{
              width: 42px;
            }
          }
        }
      }
    }
  }
  @media screen and (min-width:1281px) and (max-width:1400px){
    .index{
      display:table-cell;
      vertical-align: middle;
      position: relative;
      padding: 7.81%;
      background: -webkit-linear-gradient(#4aacf5, #208ddf); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(#4aacf5, #208ddf); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(#4aacf5, #208ddf); /* Firefox 3.6 - 15 */
      background: linear-gradient(#4aacf5, #208ddf); /* 标准的语法 */
      width: 1400px;
      height: 707px;
      // line-height: 936px;
      overflow: auto;
      .login{
        width: 1181px;
        height: 489px;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        border-radius: 15px;
        .left{
          width: 53%;
          padding: 75px 26px 26px;
          background-color: #F0FBFF;
          border-radius: 15px 0 0 15px;
          .title{
            height: 70px;
            line-height: 70px;
            text-align: center;
            img{
              width: 421px;
            }
          }
          .peoImg{
            text-align: center;
            img{
              width: 304px;
            }
          }
        }
        .right{
          position: relative;
          width: 47%;
          padding: 99px 80px 62px ;
          p{
            font-size: 26px;
            color: #3985BE;
            font-weight: 500;
            span{
              font-size: 16px;
              color: #97A5B8;
              font-weight: 400;
            }
          }
          p:last-child{
            line-height: 26px;
            span{
              display: inline-block;
              height: 26px;
              line-height: 26px;
            }
          }
          .ivu-form{
            // margin-top:32px;
            .ivu-form-item{
              margin-top: 26px;
            }
            .ivu-form-item:last-child{
              margin-top: 14px;
            }
            /deep/ .ivu-form-item-content {
              position: relative;
              line-height: 24px;
              font-size: 14px;
            }
            /deep/ .ivu-input{
              height: 52px;
              line-height: 52px;;
              font-size: 16px;
              padding-left: 18px;
            }
            /deep/ .ivu-btn{
              height: 52px;
              border-radius: 26px;
              margin-top: 28px;
              font-size: 16px;
            }
            p.copy{
              font-size: 14px;
              text-align: center;
              color:#babdc2;
            }
          }
          .light{
            position: absolute;
            top: 0;
            right: 56px;
            img{
              width: 44px;
            }
          }
        }
      }
    }
  }
  @media screen and (min-width:1401px) and (max-width:1680px){
    .index{
      display:table-cell;
      vertical-align: middle;
      position: relative;
      padding: 7.81%;
      background: -webkit-linear-gradient(#4aacf5, #208ddf); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(#4aacf5, #208ddf); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(#4aacf5, #208ddf); /* Firefox 3.6 - 15 */
      background: linear-gradient(#4aacf5, #208ddf); /* 标准的语法 */
      background-color: pink;
      width: 1680px;
      height: 849px;
      // line-height: 936px;
      overflow: auto;
      .login{
        width: 1418px;
        height: 586px;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        border-radius: 18px;
        .left{
          width: 53%;
          padding: 87px 32px 32px;
          background-color: #F0FBFF;
          border-radius: 18px 0 0 18px;
          .title{
            height: 85px;
            line-height: 85px;
            text-align: center;
            img{
              width: 505px;
            }
          }
          .peoImg{
            text-align: center;
            img{
              width: 360px;
            }
          }
        }
        .right{
          position: relative;
          width: 47%;
          padding: 119px 96px 74px ;
          p{
            font-size: 28px;
            color: #3985BE;
            font-weight: 500;
            span{
              font-size: 17px;
              color: #97A5B8;
              font-weight: 400;
            }
          }
          p:last-child{
            line-height: 28px;
            span{
              display: inline-block;
              height: 28px;
              line-height: 28px;
            }
          }
          .ivu-form{
            // margin-top:32px;
            .ivu-form-item{
              margin-top: 30px;
            }
            .ivu-form-item:last-child{
              margin-top: 18px;
            }
            /deep/ .ivu-form-item-content {
              position: relative;
              line-height: 28px;
              font-size: 15px;
            }
            /deep/ .ivu-input{
              height: 60px;
              line-height: 60px;;
              font-size: 17px;
              padding-left: 20px;
            }
            /deep/ .ivu-btn{
              height: 60px;
              border-radius: 32px;
              margin-top: 32px;
              font-size: 17px;
            }
            p.copy{
              font-size: 14px;
              text-align: center;
              color:#babdc2;
            }
          }
          .light{
            position: absolute;
            top: 0;
            right: 51px;
            img{
              width: 51px;
            }
          }
        }
      }
    }
  }
  // @media screen and (min-width:1921px){
    //   .index{
    //     display:table-cell;
    //     vertical-align: middle;
    //     position: relative;
    //     padding: 7.81%;
    //     background: -webkit-linear-gradient(#4aacf5, #208ddf); /* Safari 5.1 - 6.0 */
    //     background: -o-linear-gradient(#4aacf5, #208ddf); /* Opera 11.1 - 12.0 */
    //     background: -moz-linear-gradient(#4aacf5, #208ddf); /* Firefox 3.6 - 15 */
    //     background: linear-gradient(#4aacf5, #208ddf); /* 标准的语法 */
    //     width: 1920px;
    //     height: 936px;
    //     // line-height: 936px;
    //     overflow: auto;
    //     .login{
    //       width: 1620px;
    //       height: 670px;
    //       display: flex;
    //       justify-content: space-between;
    //       background-color: #fff;
    //       border-radius: 20px;
    //       .left{
    //         width: 53%;
    //         padding: 80px 18px 18px;
    //         background-color: #F0FBFF;
    //         border-radius: 20px;
    //         .title{
    //           height: 100px;
    //           line-height: 100px;
    //           text-align: center;
    //         }
    //         .peoImg{
    //           text-align: center;
    //         }
    //       }
    //       .right{
    //         position: relative;
    //         width: 47%;
    //         padding: 124px 110px 86px ;
    //         p{
    //           font-size: 32px;
    //           color: #3985BE;
    //           font-weight: 600;
    //           span{
    //             font-size: 18px;
    //             color: #97A5B8;
    //           }
    //         }
    //         p:last-child{
    //           line-height: 30px;
    //           span{
    //             display: inline-block;
    //             height: 30px;
    //             line-height: 30px;
    //           }
    //         }
    //         .ivu-form{
    //           // margin-top:32px;
    //           .ivu-form-item{
    //             margin-top: 40px;
    //           }
    //           .ivu-form-item:last-child{
    //             margin-top: 20px;
    //           }
    //           /deep/ .ivu-form-item-content {
    //             position: relative;
    //             line-height: 32px;
    //             font-size: 16px;
    //           }
    //           /deep/ .ivu-input{
    //             height: 64px;
    //             line-height: 64px;;
    //             font-size: 18px;
    //             padding-left: 22px;
    //           }
    //           /deep/ .ivu-btn{
    //             height: 64px;
    //             border-radius: 36px;
    //             margin-top: 35px;
    //             font-size: 18px;
    //           }
    //         }
    //         .light{
    //           position: absolute;
    //           top: 0;
    //           right: 80px;
    //         }
    //       }
    //     }
    //   }
    // }
  @media screen and (min-width:1681px) and (max-width:1920px){
    .index{
      display:table-cell;
      vertical-align: middle;
      position: relative;
      padding: 7.81%;
      background: -webkit-linear-gradient(#4aacf5, #208ddf); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(#4aacf5, #208ddf); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(#4aacf5, #208ddf); /* Firefox 3.6 - 15 */
      background: linear-gradient(#4aacf5, #208ddf); /* 标准的语法 */
      width: 1920px;
      height: 936px;
      // line-height: 936px;
      overflow: auto;
      .login{
        width: 1620px;
        height: 670px;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        border-radius: 20px;
        .left{
          width: 53%;
          padding: 80px 18px 18px;
          background-color: #F0FBFF;
          border-radius: 20px 0 0 20px;
          .title{
            height: 100px;
            line-height: 100px;
            text-align: center;
          }
          .peoImg{
            text-align: center;
          }
        }
        .right{
          position: relative;
          width: 47%;
          padding: 124px 110px 86px ;
          p{
            font-size: 32px;
            color: #3985BE;
            font-weight: 500;
            span{
              font-size: 18px;
              color: #97A5B8;
              font-weight: 400;
            }
          }
          p:last-child{
            line-height: 30px;
            span{
              display: inline-block;
              height: 30px;
              line-height: 30px;
            }
          }
          .ivu-form{
            // margin-top:32px;
            .ivu-form-item{
              margin-top: 40px;
            }
            .ivu-form-item:last-child{
              margin-top: 20px;
            }
            /deep/ .ivu-form-item-content {
              position: relative;
              line-height: 32px;
              font-size: 16px;
            }
            /deep/ .ivu-input{
              height: 64px;
              line-height: 64px;;
              font-size: 18px;
              padding-left: 22px;
            }
            /deep/ .ivu-btn{
              height: 64px;
              border-radius: 36px;
              margin-top: 35px;
              font-size: 18px;
            }
             p.copy{
              font-size: 14px;
              text-align: center;
              color:#babdc2;
            }
          }
          .light{
            position: absolute;
            top: 0;
            right: 80px;
          }
        }
      }
    }
  }
  @media screen and (min-width:1921px){
    .index{
      display:block;
      margin: 0 auto;
      position: relative;
      padding: 7.81%;
      background: -webkit-linear-gradient(#4aacf5, #208ddf); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(#4aacf5, #208ddf); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(#4aacf5, #208ddf); /* Firefox 3.6 - 15 */
      background: linear-gradient(#4aacf5, #208ddf); /* 标准的语法 */
      width: 100%;
      height: 100%;
      overflow: auto;
      .login{
        width: 100%;
        height: 670px;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        border-radius: 20px;
        .left{
          width: 53%;
          padding: 80px 18px 18px;
          background-color: #F0FBFF;
          border-radius: 20px 0 0 20px;
          .title{
            height: 100px;
            line-height: 100px;
            text-align: center;
          }
          .peoImg{
            text-align: center;
          }
        }
        .right{
          position: relative;
          width: 47%;
          padding: 124px 110px 86px ;
          p{
            font-size: 32px;
            color: #3985BE;
            font-weight: 500;
            span{
              font-size: 18px;
              color: #97A5B8;
              font-weight: 400;
            }
          }
          p:last-child{
            line-height: 30px;
            span{
              display: inline-block;
              height: 30px;
              line-height: 30px;
            }
          }
          .ivu-form{
            // margin-top:32px;
            .ivu-form-item{
              margin-top: 40px;
            }
            .ivu-form-item:last-child{
              margin-top: 20px;
            }
            /deep/ .ivu-form-item-content {
              position: relative;
              line-height: 32px;
              font-size: 16px;
            }
            /deep/ .ivu-input{
              height: 64px;
              line-height: 64px;;
              font-size: 18px;
              padding-left: 22px;
            }
            /deep/ .ivu-btn{
              height: 64px;
              border-radius: 36px;
              margin-top: 35px;
              font-size: 18px;
            }
            p.copy{
              font-size: 14px;
              text-align: center;
              color:#babdc2;
            }
          }
          .light{
            position: absolute;
            top: 0;
            right: 80px;
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Login.vue